import useFlag from 'hooks/useFlag'

/** Gates the canonical SKU picker. thanx-ai reads the same key before it sends a canonical picker. */
const useCanonicalPickers = (): boolean =>
  useFlag('ai-canonical-pickers-enabled', false)

export default useCanonicalPickers
